import { render, staticRenderFns } from "./ArticlesByCategory.vue?vue&type=template&id=12e13358&"
import script from "./ArticlesByCategory.vue?vue&type=script&lang=js&"
export * from "./ArticlesByCategory.vue?vue&type=script&lang=js&"
import style0 from "./ArticlesByCategory.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArticlesByCategory.vue"
export default component.exports